<script>
import { Line, mixins } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import _ from 'underscore'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['height','yAxesCurrencyBrl'],
  mounted () {
    if (!this.chartData) return;
    const brandInfo = '#5164a9'
    const brandDanger = '#f86c6b'

    let allValues = _.union(this.chartData.apple, this.chartData.google);
    let yAxesMax = allValues.length ? Math.max(...allValues) + 1 : 1;

    let datasets = [
      {
        label: 'Apple',
        backgroundColor: "#f4f4f6",
        borderColor: brandInfo,
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: this.chartData.apple
      },
      {
        label: 'Google',
        backgroundColor: 'transparent',
        borderColor: brandDanger,
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: this.chartData.google
      }
    ]

    this.renderChart({
      labels: this.chartData.labels,
      datasets
    }, {
      tooltips: {
        enabled: false,
        custom: CustomTooltips,
        intersect: true,
        mode: 'index',
        position: 'nearest',
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
          },
          label: (tooltipItem, data) => {
            const label = data.datasets[tooltipItem.datasetIndex].label || '';
            let value = tooltipItem.value;
            if(this.yAxesCurrencyBrl){
              value = ' R$ ' + parseFloat(value).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
            }
            return label + ': ' + value;
          }
        }
      },
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 5,
            stepSize: Math.ceil(yAxesMax / 5),
            max: yAxesMax,
            callback: (value) =>{
              if (this.yAxesCurrencyBrl) {
                return 'R$ ' + value.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
              }
              return value;
            }
          },
          gridLines: {
            display: true
          }
        }]
      },
      elements: {
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
    })
  }
}
</script>
